import React from 'react';
import { Bot, User, Loader2, Send } from 'lucide-react';

export function ChatMessageList({ messages, isLoading, error, messagesEndRef, compact = false }) {
  const avatarCls = compact ? 'w-8 h-8' : 'w-10 h-10';
  const iconSize = compact ? 16 : 18;
  const bubblePad = compact ? 'p-3' : 'p-4';

  return (
    <>
      {messages.map((msg, index) => (
        <div
          key={`${msg.role}-${index}`}
          className={`flex items-start gap-3 ${msg.role === 'user' ? 'flex-row-reverse' : ''}`}
        >
          <div className={`${avatarCls} rounded-full flex items-center justify-center flex-shrink-0 ${msg.role === 'user' ? 'bg-slate-200' : 'bg-rose-100'}`}>
            {msg.role === 'user' ? <User size={iconSize} className="text-slate-600" /> : <Bot size={iconSize} className="text-rose-600" />}
          </div>
          <div className={`max-w-[80%] ${bubblePad} text-sm ${msg.role === 'user' ? 'bg-slate-900 text-white rounded-t-2xl rounded-bl-2xl' : 'bg-slate-100 text-slate-800 rounded-t-2xl rounded-br-2xl'}`}>
            <p className="whitespace-pre-wrap">{msg.content}</p>
          </div>
        </div>
      ))}

      {isLoading && (
        <div className="flex items-start gap-3">
          <div className={`${avatarCls} bg-rose-100 rounded-full flex items-center justify-center`}>
            <Bot size={iconSize} className="text-rose-600" />
          </div>
          <div className={`bg-slate-100 ${bubblePad} rounded-t-2xl rounded-br-2xl`}>
            <div className="flex items-center gap-2">
              <Loader2 className="animate-spin text-slate-400" size={16} />
              <span className="text-sm text-slate-500">Escribiendo...</span>
            </div>
          </div>
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 p-3 rounded text-xs text-red-700">{error}</div>
      )}

      <div ref={messagesEndRef} />
    </>
  );
}

export function ChatInput({ onSubmit, inputMessage, setInputMessage, isLoading, inputRef, testIdPrefix = 'chat', placeholder = 'Escribe tu pregunta...', compact = false }) {
  const pad = compact ? 'p-3' : 'p-4';
  return (
    <form onSubmit={onSubmit} className={`${pad} border-t border-slate-200 flex-shrink-0`}>
      <div className="flex items-center gap-2">
        <input
          ref={inputRef}
          type="text"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          placeholder={placeholder}
          disabled={isLoading}
          className={`flex-1 ${pad} border border-slate-200 text-sm focus:border-rose-500 focus:outline-none disabled:opacity-50`}
          data-testid={`${testIdPrefix}-input`}
          maxLength={2000}
        />
        <button
          type="submit"
          disabled={isLoading || !inputMessage.trim()}
          className={`${pad} bg-rose-600 text-white hover:bg-rose-700 transition disabled:opacity-50 disabled:cursor-not-allowed`}
          data-testid={`${testIdPrefix}-send`}
        >
          <Send size={18} />
        </button>
      </div>
      {compact && (
        <p className="text-[10px] text-slate-400 mt-2 text-center">
          Este asistente usa IA (GPT-4o-mini). No proporciona asesoramiento legal vinculante.{' '}
          <a href="/legal/transparencia-ia" target="_blank" rel="noopener noreferrer" className="underline hover:text-slate-600">Transparencia IA</a>
        </p>
      )}
    </form>
  );
}
